<script>
import { mapActions } from "vuex";
import t from '@/components/ui/text.json';

export default {
  data() {
    return {
      t,
      stage: 1,
    };
  },
  methods: {
    ...mapActions(["switchConfirmPopup"]),

    reload() {
      window.location.reload();
    },
  },
};
</script>

<template>
  <div class="popup-confirm">
    <div v-if="stage === 1" class="content">
      <div class="popup-confirm__icon">
        <img src="@/assets/icons/ui/dd_1.svg" />
      </div>

      <p class="popup-confirm__text">
        {{ t.popupConfirm.text1 }}
      </p>

      <div class="popup-confirm__btns">
        <div
          class="popup-confirm__btn popup-confirm__btn--right"
          @click="switchConfirmPopup(false)"
        >
          <p>{{ t.popupConfirm.text2 }}</p>
        </div>

        <div
          class="popup-confirm__btn popup-confirm__btn-type2"
          @click="stage = 2"
        >
          <p>{{ t.popupConfirm.text3 }}</p>
        </div>
      </div>
    </div>

    <div v-else class="content">
      <div class="popup-confirm__icon popup-confirm__icon--icon2">
        <img src="@/assets/icons/ui/dd_2.svg" />
      </div>

      <p class="popup-confirm__text">
        {{ t.popupConfirm.text4 }}
      </p>

      <div class="popup-confirm__btns">
        <div
          class="popup-confirm__btn popup-confirm__btn--single"
          @click="reload"
        >
          <p>{{ t.popupConfirm.text5 }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.popup-confirm {
  position: fixed;

  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  z-index: 400;

  padding: 20px;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  background: rgba(14, 45, 34, 0.9);
  backdrop-filter: blur(3px);

  .content {
    padding: 40px;

    display: flex;
    flex-direction: column;
    align-items: flex-start;

    max-width: 648px;
    width: 100%;

    max-height: 400px;
    height: 100%;

    border-radius: 40px 90px 40px 40px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(66.66667175292969px);

    @media screen and (max-width: 600px) {
      padding: 20px;
    }
  }

  &__icon {
    margin-bottom: 20px;
    width: 62px;
    height: 46px;

    &--icon2 {
      width: 46px;
      height: 46px;
    }
  }

  &__text {
    color: var(--Text-White, #fff);
    font-size: 24px;
    font-weight: 700;
    line-height: 1.2;
  }

  &__btns {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;

    margin-top: auto;
    width: 100%;

    @media screen and (min-width: 525px) {
      justify-content: center;
    }
  }

  &__btn {
    position: relative;
    overflow: hidden;

    display: flex;
    justify-content: center;
    align-items: center;

    padding: 8px 10px;

    max-width: 280px;
    width: 100%;
    height: 60px;

    border-radius: 60px;
    // box-shadow: 0px 7px 20.1px 0px rgba(156, 255, 172, 0.5);

    & > * {
      position: relative;
      z-index: 1;
    }

    &::before,
    &::after {
      content: "";
      position: absolute;
      border-radius: 60px;
    }

    &::before {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      background: radial-gradient(
        100% 100% at 50% 0%,
        rgba(255, 255, 255, 0.3) 0%,
        rgba(255, 255, 255, 0) 100%
      );
    }

    &::after {
      top: 2px;
      left: 2px;
      width: calc(100% - 4px);
      height: calc(100% - 4px);
    }

    &,
    &::after {
      background: radial-gradient(
          100% 100% at 50% 0%,
          rgba(255, 255, 255, 0.3) 0%,
          rgba(255, 255, 255, 0) 100%
        ),
        linear-gradient(0deg, #01cb93 0%, #60fe94 100%) #60fe94;
    }

    @media screen and (max-width: 600px) {
      max-width: 100%;
    }

    @media screen and (min-width: 1024px) {
      user-select: none;
      cursor: pointer;

      &:hover {
        &::before {
          background: radial-gradient(
            100% 100% at 50% 0%,
            rgba(255, 255, 255, 1) 0%,
            rgba(255, 255, 255, 0) 100%
          );
        }

        &,
        &::after {
          background: radial-gradient(
              100% 100% at 50% 0%,
              rgba(255, 255, 255, 0.3) 0%,
              rgba(255, 255, 255, 0) 100%
            ),
            linear-gradient(0deg, #00a175 0%, #60fe94 100%) #60fe94;
          // linear-gradient(0deg, #01cb93 0%, #60fe94 100%) #60fe94;
        }
      }

      &:active {
        &,
        &::after {
          background: radial-gradient(
              40% 40% at 50% 0%,
              rgba(255, 255, 255, 0.8) 0%,
              rgba(255, 255, 255, 0) 100%
            ),
            linear-gradient(0deg, #00a175 0%, #60fe94 100%) #60fe94;
        }
      }
    }

    p {
      color: var(--White, #fff);
      text-align: center;
      font-size: 18px;
      font-weight: 700;
      line-height: 1;
      letter-spacing: 0.36px;
      text-transform: uppercase;
    }

    &--right {
      // margin-right: 16px;
    }

    &--single {
      max-width: 280px;

      @media screen and (max-width: 600px) {
        max-width: 132px;
      }
    }

    // &:active {
    //   user-select: none;
    //   background: rgba(228, 130, 255, 0.1);
    //   cursor: pointer;
    //   p { color: #ffffff !important; }
    //   &:before { opacity: 0; }
    //   &:after { opacity: 0; }
    // }

    &-type2 {
      border-radius: 60px;
      // box-shadow: 0px 7px 20.1px 0px rgb(255, 221, 134, 0.5);

      &,
      &::after {
        background: radial-gradient(
            100% 100% at 50% 0%,
            rgba(255, 255, 255, 0.3) 0%,
            rgba(255, 255, 255, 0) 100%
          ),
          linear-gradient(0deg, #c97f57 0%, #ffb950 100%) #ffdd86;
      }

      @media screen and (min-width: 1024px) {
        &:hover,
        &:hover:after {
          background: radial-gradient(
              100% 100% at 50% 0%,
              rgba(255, 255, 255, 0.3) 0%,
              rgba(255, 255, 255, 0) 100%
            ),
            linear-gradient(0deg, #e97130 0%, #ffa825 100%) #ffa825;
        }

        &:active,
        &:active:after {
          background: radial-gradient(
              40% 40% at 50% 0%,
              rgba(255, 255, 255, 0.8) 0%,
              rgba(255, 255, 255, 0) 100%
            ),
            linear-gradient(0deg, #da753e 0%, #ffb341 100%) #ffb341;
        }
      }
    }
  }
}
</style>
